module.exports = __webpack_public_path__ + "static/media/fly0210.aa4cf7be.webp";